
/**
 * Created by lari on 03/09/15.
 */
(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name consult.factory:ConsultService
   *
   * @description
   *
   */
  angular
    .module('vcconsult')
    .factory('Consult', Consult)
    .config(config);
  
  config.$inject = ['restmodProvider'];
  
  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }
  
  Consult.$inject = ['restmod'];
  
  function Consult(restmod) {
    return restmod.model('/routes/consults').mix({
      client: {belongsTo: 'Client', key: 'clientid'},
      examinations: {hasMany: 'Exam'},
      documents: {hasMany: 'Document'},
      files: {hasMany: 'File'},
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      open: {init: true},
      state: {init: 'edit'},
      symptoms: {init: ''},
      findings: {init: ''},
      therapy: {init: ''},
      keywords: {init: []},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/consults/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            realquery['active'] = true;
            return this.$search(realquery);
          }
        } // Model
      }// extend
    });
  }
  
}());
